export type ChatMessage = {
  from: 'them' | 'me'
  text: string
  time: string
}

export type WhatsAppChat = {
  name: string
  status: string
  avatar: string
  messages: ChatMessage[]
}

export const whatsappChats: WhatsAppChat[] = [
  {
    name: 'Javier — Monitor en Madrid',
    status: 'en línea',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/0655d861-5f09-4a62-80b6-831110358279.jpg',
    messages: [
      {
        from: 'them',
        text: 'Hola, ya compré el Padel Pro-Pack y quería decirte que está genial 🙌',
        time: '10:32',
      },
      { from: 'me', text: 'Qué bien Javier! Me alegra que te esté sirviendo 💪', time: '10:34' },
      {
        from: 'them',
        text: 'Muy completo. Me está ayudando a organizar todo el año de sesiones. Los bonos son una pasada.',
        time: '10:36',
      },
      {
        from: 'them',
        text: 'Ya lo he recomendado a otros monitores del club. Gracias por el material 🔥',
        time: '10:40',
      },
    ],
  },
  {
    name: 'Carmen — Monitora en Sevilla',
    status: 'en línea',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/645d01d6-8d45-4bf6-b2bd-32029e2e340b.jpg',
    messages: [
      {
        from: 'them',
        text: 'Te cuento: usé el plan de iniciación del Tomo 5 con el grupo de las 9 y salió redondo.',
        time: '18:05',
      },
      { from: 'me', text: '¡Genial! ¿Y cómo reaccionaron las alumnas?', time: '18:07' },
      {
        from: 'them',
        text: 'Me pidieron añadir una sesión más por semana 😅 Antes improvisaba todo el domingo por la noche.',
        time: '18:11',
      },
      { from: 'me', text: 'Eso es exactamente para lo que está hecho 🎾', time: '18:12' },
    ],
  },
  {
    name: 'Diego — Monitor en Bilbao',
    status: 'últ. vez hoy a las 21:14',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/85e55bc8-a78b-41ab-ad6d-1af83b07df03.jpg',
    messages: [
      {
        from: 'them',
        text: 'Con el tracker les mostré el progreso del mes y subí la hora de 25 a 35 € sin que nadie se quejase.',
        time: '21:02',
      },
      { from: 'me', text: 'Te lo dije, la evidencia vende sola 😄', time: '21:05' },
      {
        from: 'them',
        text: 'Tres alumnos me pagaron el bono de 10 sesiones por adelantado esta semana.',
        time: '21:09',
      },
      {
        from: 'them',
        text: 'Lo mejor: recuperé mis fines de semana. Gracias en serio 🙏',
        time: '21:14',
      },
    ],
  },
]
